import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, Paper } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import endpoint from "../../config/endpoints";
import {
  jsonMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
} from "../../config/messageconstant";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { BillingHistoryPopUpJson } from "../../DynamicFormsJson/Transaction/billingHistoryPopUp";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import dayjs from "dayjs";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const BillingHistoryPopup = ({
  handleCloses,
  open,
  editData,
  showLoador,
  showNotification,
}) => {
  const [name, setName] = React.useState("");
  const [formErrors, setFormErrors] = React.useState({});

  React.useEffect(() => { }, []);
  const handleClose = () => {
    handleCloses();
  };

  const onSubmit = (data) => {
    if (navigator.onLine) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let billingObject = {
            ackNo: data.ackNo,
            ackDate: data.ackDate,
            signedInvoice: data.signedInvoice,
            signedQRCode: data.signedQRCode,
          };
          let billingObjectJSON = JSON.stringify(billingObject);
          onSave(billingObjectJSON);

        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const onSave = (billingObjectJSON) => {
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url:
          endpoint.outletBillHeader +
          "/import-invoice-json?outletBillHeaderId=" +
          editData + "&invoiceJson=" + billingObjectJSON,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: savemsg });
          window.location.replace("/billing-history");
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  return (
    <>
      <Paper sx={{ p: 12, pt: 8, borderRadius: 8 }} elevation={0}>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
          maxWidth="xl"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            <DynamicFormWithoutSave
              showBackToList={false}
              showSaveBtn={true}
              showSaveBtnMain={false}
              showTitle={BillingHistoryPopUpJson.showTitle}
              screenTitle={BillingHistoryPopUpJson.screenTitle}
              fieldMeta={BillingHistoryPopUpJson.fieldMeta}
              showCancel={BillingHistoryPopUpJson.showCancel}
              apiBaseURL={BillingHistoryPopUpJson.apiBaseURL}
              showSaveNextBtn={BillingHistoryPopUpJson.showSaveNextBtn}
              saveBtnText={"Submit"}
              onSave={onSubmit}
            />
          </BootstrapDialogTitle>
        </BootstrapDialog>
      </Paper>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = { showNotification, showLoador };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingHistoryPopup);
